import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { convertUtcToLocal } from '../helpers/dateHelper';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  // Запрос кампании
  campaignRequest: ['id'],
  campaignSuccess: ['data'],
  campaignFailure: ['error'],

  // Создание кампании
  createCampaignRequest: ['campaign'],
  createCampaignSuccess: ['data'],
  createCampaignFailure: ['error'],

  // Создание кампании
  updateCampaignRequest: ['campaign'],
  updateCampaignSuccess: ['data'],
  updateCampaignFailure: ['error'],

  // Удаление кампании
  deleteCampaignRequest: ['id'],
  deleteCampaignSuccess: ['data'],
  deleteCampaignFailure: ['error'],

  // Загрузка VIN-файла
  uploadVinFileRequest: ['id', 'file'],
  uploadVinFileSuccess: ['data'],
  uploadVinFileFailure: ['error'],

  // Загрузка распарсенных VIN
  uploadParsedVinsRequest: ['id', 'parsedVins'],
  uploadParsedVinsSuccess: ['data'],
  uploadParsedVinsFailure: ['error'],

  // Применение фильтров автомобилей
  uploadCarsFilterRequest: ['id', 'rules'],
  uploadCarsFilterSuccess: ['data'],
  uploadCarsFilterFailure: ['error'],

  resetCampaignState: null,
});

export const CampaignTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  campaign: {},
  error: null,
  fetching: false,
  vins: [],
  notFoundCarVins: [],
  cars: []
});

/* ------------- Reducers ------------- */

// Общий запрос
export const request = (state) => state.merge({ fetching: true, error: null });

// Общий отказ
export const failure = (state, { error }) => state.merge({ fetching: false, error });

// Успешный запрос кампании
export const campaignSuccess = (state, { data }) =>
  state.merge({
    fetching: false, error: null, campaign: {
      ...data,
      startDateTime: convertUtcToLocal(data.startDateTime),
      endDateTime: convertUtcToLocal(data.endDateTime)
    }, cars: data?.cars, notFoundCarVin: []
  });

// Успешное удаление кампании
export const deleteCampaignSuccess = (state) =>
  state.merge({ fetching: false, error: null});

// Успешная загрузка VIN-файла
export const uploadVinFileSuccess = (state, { data }) =>
  state.merge({
    fetchingCars: false,
    error: null,
    notFoundCarVins: data.notFoundCarVin,
    cars: data.cars
  });

export const requestUpload = (state) => state.merge({ fetchingCars: true });

// Успешная загрузка распарсенных VIN
export const uploadParsedVinsSuccess = (state, { data }) =>
  state.merge({
    fetchingCars: false,
    error: null,
    notFoundCarVins: data.notFoundCarVin,
    cars: data.cars
  });


export const uploadParsedVinsfailure = (state, { error }) =>
  state.merge({
    fetchingCars: false,
    error,
    file: null
  });

// Успешное применение фильтра автомобилей
export const uploadCarsFilterSuccess = (state, { data }) =>
  state.merge({
    fetchingCars: false,
    error: null,
    notFoundCarVins: [],
    cars: data
  });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  // Запрос кампании
  [Types.CAMPAIGN_REQUEST]: request,
  [Types.CAMPAIGN_SUCCESS]: campaignSuccess,
  [Types.CAMPAIGN_FAILURE]: failure,

  // Создание кампании
  [Types.CREATE_CAMPAIGN_REQUEST]: request,
  [Types.CREATE_CAMPAIGN_SUCCESS]: campaignSuccess,
  [Types.CREATE_CAMPAIGN_FAILURE]: failure,

  // Редактирование кампании
  [Types.UPDATE_CAMPAIGN_REQUEST]: request,
  [Types.UPDATE_CAMPAIGN_SUCCESS]: campaignSuccess,
  [Types.UPDATE_CAMPAIGN_FAILURE]: failure,

  // Удаление кампании
  [Types.DELETE_CAMPAIGN_REQUEST]: request,
  [Types.DELETE_CAMPAIGN_SUCCESS]: deleteCampaignSuccess,
  [Types.DELETE_CAMPAIGN_FAILURE]: failure,

  // Загрузка VIN-файла
  [Types.UPLOAD_VIN_FILE_REQUEST]: requestUpload,
  [Types.UPLOAD_VIN_FILE_SUCCESS]: uploadVinFileSuccess,
  [Types.UPLOAD_VIN_FILE_FAILURE]: uploadParsedVinsfailure,

  // Загрузка распарсенных VIN
  [Types.UPLOAD_PARSED_VINS_REQUEST]: requestUpload,
  [Types.UPLOAD_PARSED_VINS_SUCCESS]: uploadParsedVinsSuccess,
  [Types.UPLOAD_PARSED_VINS_FAILURE]: failure,

  // Применение фильтров автомобилей
  [Types.UPLOAD_CARS_FILTER_REQUEST]: requestUpload,
  [Types.UPLOAD_CARS_FILTER_SUCCESS]: uploadCarsFilterSuccess,
  [Types.UPLOAD_CARS_FILTER_FAILURE]: failure
});
